// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pack-text-shadow{text-shadow:0 2px 4px #000}.dropzone{height:auto!important;min-height:auto!important}.dropzone,.dz-message{padding:0!important;margin:0!important}", ""]);
// Exports
module.exports = exports;
